import { useState } from 'react';
import AudioPlayer from './AudioPlayer';
import './ChapterDisplay.css';

const ChapterDisplay = ({ chapter, chapterText, format, onChapterFinished }) => {
  const [fontSize, setFontSize] = useState('medium');

  if (!chapter) {
    return (
      <div className="chapter-display empty">
        <p>No chapter selected</p>
      </div>
    );
  }

  if (!chapterText) {
    return (
      <div className="chapter-display empty">
        <h2>{chapter.book} {chapter.chapter}</h2>
        <p>Chapter text not available</p>
      </div>
    );
  }

  const handleFontSizeChange = (size) => {
    setFontSize(size);
  };

  const getFontSizeClass = () => {
    switch (fontSize) {
      case 'small': return 'font-small';
      case 'large': return 'font-large';
      case 'extra-large': return 'font-extra-large';
      default: return 'font-medium';
    }
  };

  return (
    <div className="chapter-display">
      <div className="chapter-header">
        <div className="chapter-title">
          <h2>{chapter.book} {chapter.chapter}</h2>
          <div className="chapter-meta">
            <span className="testament">{chapter.testament} Testament</span>
            <span className="verse-count">{chapter.verseCount} verses</span>
            {chapterText.canonical && (
              <span className="canonical">({chapterText.canonical})</span>
            )}
          </div>
        </div>

        <div className="chapter-display-controls">
          <div className="font-size-controls">
            <label>Text size:</label>
            <button
              className={`size-btn ${fontSize === 'small' ? 'active' : ''}`}
              onClick={() => handleFontSizeChange('small')}
              title="Small font"
            >
              A
            </button>
            <button
              className={`size-btn ${fontSize === 'medium' ? 'active' : ''}`}
              onClick={() => handleFontSizeChange('medium')}
              title="Medium font"
            >
              A
            </button>
            <button
              className={`size-btn ${fontSize === 'large' ? 'active' : ''}`}
              onClick={() => handleFontSizeChange('large')}
              title="Large font"
            >
              A
            </button>
            <button
              className={`size-btn ${fontSize === 'extra-large' ? 'active' : ''}`}
              onClick={() => handleFontSizeChange('extra-large')}
              title="Extra large font"
            >
              A
            </button>
          </div>
        </div>
      </div>

      <div className={`chapter-content ${getFontSizeClass()}`}>
        {format === 'html' ? (
          <div 
            className="chapter-text html"
            dangerouslySetInnerHTML={{ __html: chapterText.passage }}
          />
        ) : (
          <div className="chapter-text plain">
            {chapterText.passage.split('\n').map((line, index) => {
              // Handle paragraph breaks and verse formatting
              if (line.trim() === '') {
                return <br key={index} />;
              }
              
              return (
                <p key={index} className="verse-line">
                  {line}
                </p>
              );
            })}
          </div>
        )}
      </div>

      <AudioPlayer chapter={chapter} onChapterFinished={onChapterFinished} />

      <div className="chapter-footer">
        <div className="reading-progress">
          <span>Reading {chapter.book} {chapter.chapter}</span>
          {chapterText.canonical && chapterText.canonical !== `${chapter.book} ${chapter.chapter}` && (
            <span className="esv-reference"> • ESV: {chapterText.canonical}</span>
          )}
        </div>
        
        <div className="esv-attribution">
          <small>
            Scripture quotations are from the ESV® Bible (The Holy Bible, English Standard Version®)
          </small>
        </div>
      </div>
    </div>
  );
};

export default ChapterDisplay;
